import { Award, Sparkles, FileText } from "lucide-react";

export const About = () => (
  <section id="apropos" className="py-24 md:py-32 bg-[#E6D7FF]/40" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-5">
        <div className="relative inline-block">
          <div className="absolute -inset-3 bg-[#FFF3B0] rounded-[3rem] -rotate-3" />
          <img
            src="/images/loraine-b.jpg"
            alt="Loraine B."
            className="relative w-full max-w-md aspect-[4/5] object-cover border-2 border-black rounded-[3rem] shadow-brutal"
          />
        </div>
      </div>

      <div className="lg:col-span-7">
        <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#FF6B6B]">
          À propos
        </span>
        <h2 className="mt-3 font-display text-5xl md:text-7xl leading-none uppercase">
          Loraine B<span className="text-[#8B5CF6]">.</span>
        </h2>
        <p className="mt-3 font-sans text-base font-bold tracking-widest uppercase text-[#3a3a3a]">
          Professeure DE · Artiste · Musicienne · Pays Basque
        </p>

        <div className="mt-7 space-y-5 text-lg leading-relaxed text-[#1a1a1a]">
          <p>
            Danseuse, comédienne, improvisatrice, chanteuse — je navigue entre les disciplines depuis plus de 10 ans.
          </p>
          <p>
            L'Atelier, c'est mon espace pour transmettre tout ça — bouger autrement, créer sans jugement, oser être soi. Ici, pas de niveau attendu, pas de jugement. On commence par où on est, et on avance ensemble.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href="/docs/diplome-loraine-begard.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-diplome-link"
            className="inline-flex items-center gap-2 bg-white border-2 border-black rounded-full px-4 py-2 shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all group"
          >
            <Award size={16} />
            <span className="font-sans text-sm font-bold">Diplôme d'État en danse</span>
            <FileText size={14} className="text-[#FF6B6B] group-hover:translate-x-0.5 transition-transform" />
          </a>
          <div className="inline-flex items-center gap-2 bg-white border-2 border-black rounded-full px-4 py-2 shadow-brutal-sm">
            <Sparkles size={16} />
            <span className="font-sans text-sm font-bold">10+ ans de scène</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
